import { FidelityCustomerFieldEnum } from "@/enum/fidelityCustomerField.enum.ts";
import {
  FidelityCardCustomerConfigFieldDto,
  FidelityCustomerDto,
} from "@/dto/fidelityCustomer.dto.ts";

export interface FidelityCardCustomerConfigField {
  id: string;
  name: string;
  mandatory: boolean;
  type: FidelityCustomerFieldEnum;
  text: { [languageCode: string]: string };
}

export interface FidelityCustomer {
  name: FidelityCustomerFieldEnum;
  surname: FidelityCustomerFieldEnum;
  phone: FidelityCustomerFieldEnum;
  email: FidelityCustomerFieldEnum;
  address: FidelityCustomerFieldEnum;
  birthdate: FidelityCustomerFieldEnum;
  additionalData: FidelityCardCustomerConfigField[];
  privacyPolicy: FidelityCardCustomerConfigField[];
}

function fromDtoToFidelityCardCustomerConfigField(
  dto: FidelityCardCustomerConfigFieldDto
): FidelityCardCustomerConfigField {
  return {
    id: dto.id,
    name: dto.name,
    mandatory: dto.mandatory,
    text: dto.text,
    type: dto.type,
  };
}

export function fromDtoToFidelityCustomer(
  dto: FidelityCustomerDto
): FidelityCustomer {
  return {
    name: dto.name,
    surname: dto.surname,
    phone: dto.phone,
    email: dto.email,
    address: dto.address,
    birthdate: dto.birthdate,
    additionalData:
      dto?.additionalData?.map(fromDtoToFidelityCardCustomerConfigField) ?? [],
    privacyPolicy:
      dto.privacyPolicy?.map(fromDtoToFidelityCardCustomerConfigField) ?? [],
  };
}
